module.exports = __webpack_public_path__ + "static/media/WarningIcon.706109e0.svg";